import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD, CHANGE_PASSWORD, CHANGE_SELF_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError, userChangePasswordSuccess, userChangePasswordError } from "./actions"

//Include Both Helper File with needed methods
import {
  postJwtForgetPwd,
  postJwtChangePwd,
  changePasswd,
} from "../../../helpers/fakebackend_helper"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: user }) {
  try {
    const response = yield call(postJwtForgetPwd, user)

    // Cognito sends response.codeDeliveryDetails when successful
    if (response && response.CodeDeliveryDetails) {
      yield put(
        userForgetPasswordSuccess(
          "If this username is associated with an account, you’ll receive a reset code shortly."
        )
      )
    } else {
      throw new Error("Unknown error initiating password reset.")
    }

  } catch (error) {
    // Extract readable message
    const message =
      error.code === "UserNotFoundException"
        ? "No account exists with that username or email."
        : error.message || "Unable to process password reset."

    yield put(userForgetPasswordError(message))
  }
}

function* resetPassword({ payload: { user, code, password, history } }) {
  try {
    const response = yield call(postJwtChangePwd, user, code, password)

    yield put(userChangePasswordSuccess("Password reset successful."))

  } catch (error) {
    const message =
      error.code === "CodeMismatchException"
        ? "The verification code is incorrect."
        : error.code === "ExpiredCodeException"
          ? "The verification code has expired."
          : error.message || "Unable to reset password."

    yield put(userChangePasswordError(message))
  }
}

function* changeSelfPassword({ payload: {oldPassword, newPassword} }) {
  try {
     console.log (oldPassword + "::" + newPassword)
     const response = yield call(changePassword, oldPassword, newPassword)
     if (response) {
        yield put (
           userChangePasswordSuccess("success")
        )
     }
  } catch (error) {
    console.log(error)
    yield put(userChangePasswordError(error))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
  yield takeEvery(CHANGE_PASSWORD, resetPassword)
  yield takeEvery(CHANGE_SELF_PASSWORD, changeSelfPassword)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
